import { atomWithMutation } from 'jotai-tanstack-query'
import {
  deliveryDateAtom,
  recipeContentsAtom,
} from '@mindfulchefuk/store/onboarding'
import { createOnboardingPreview } from './createOnboardingPreview'

export const postOnboardingPreview = atomWithMutation((get) => ({
  mutationFn: () =>
    createOnboardingPreview({
      recipe_contents: get(recipeContentsAtom),
      code_string: 'NEW25X4',
      delivery_date: get(deliveryDateAtom),
    }),
  cacheTime: 900000, // 15 minutes
}))
